import React from 'react';
import { scopeChipUnselected } from './chatViewTheme';

export default function ScopePickButtons({ picks, onSelect, disabled }: any) {
  if (!picks?.length) return null;
  return (
    <div className="mt-2 flex max-w-[85%] flex-wrap gap-2">
      {picks.map((pick, i) => (
        <button
          key={`${pick.kind || 'pick'}-${pick.id || i}`}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(pick)}
          className={`${scopeChipUnselected} disabled:opacity-50`}
        >
          {pick.label || `${pick.kind}: ${pick.id}`}
        </button>
      ))}
    </div>
  );
}
